
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import CustomModalOperator from "./CustomModalOperator";
import ReportIssuModal from "./ReportIssuModal";
import { IoMdCheckmark } from "react-icons/io";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from 'react-toastify';
import { TbLoader3 } from "react-icons/tb";
import Select from "react-select";
import '../../App.css';
import { useProductionContext } from "../../context/ProductionContext";
const numberOptions = [1, 2, 4, 6, 8, 10, 12, "Other"];
export default function LogProductionFrane2({ machineId, machineName, machineCode, productName }) {
  const [showModal, setShowModal] = useState(false);
  const [reportIssuModal, setReportIssuModal] = useState(false);
  const [producedUnits, setProducedUnits] = useState(0);
  const [recycledUnits, setRecycleUnits] = useState(0);
  const [isProducedCustom, setIsProducedCustom] = useState(false);
  const [isRejectedCustom, setIsRejectedCustom] = useState(false);
  const [customProduced, setCustomProduced] = useState("0");
  const [customRecycle, setCustomRecycle] = useState("0");
  const [notes, setNotes] = useState("");
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const { cycleStarted, setCycleStarted, machineUtilization, setMachineUtilization, cycleTime, setCycleTime } = useProductionContext();
  const handleProducedSelect = (value) => {
    if (!cycleStarted) return;
    if (value === "Other") {
      setIsProducedCustom(true);
      setProducedUnits(0);
      setCustomProduced("0");
    } else {
      setIsProducedCustom(false);
      setProducedUnits(Number(value));
      setCustomProduced(value.toString());
    }
  };
  const increaseProduced = () => {
    if (!cycleStarted) return;
    const next = producedUnits + 1;
    setProducedUnits(next);
    setCustomProduced(next.toString());
  };
  const decreaseProduced = () => {
    if (!cycleStarted) return;
    const next = producedUnits > 0 ? producedUnits - 1 : 0;
    setProducedUnits(next);
    setCustomProduced(next.toString());
  };
  const handleRejectedSelect = (value) => {
    if (value === "Other") {
      if (!cycleStarted) return;
      setIsRejectedCustom(true);
      setRecycleUnits(0);
      setCustomRecycle("0");
    } else {
      setIsRejectedCustom(false);
      setRecycleUnits(Number(value));
      setCustomRecycle(value.toString());
    }
  };
  const increaseRejected = () => {
    if (!cycleStarted) return;
    const next = recycledUnits + 1;
    setRecycleUnits(next);
    setCustomRecycle(next.toString());
  };
  const decreaseRejected = () => {
    if (!cycleStarted) return;
    const next = recycledUnits > 0 ? recycledUnits - 1 : 0;
    setRecycleUnits(next);
    setCustomRecycle(next.toString());
  };
  const startProductionCycle = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.post(
        `${config.API}/production/cycle`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        toast.success(response.data.message || "Production cycle started successfully");
        setMachineUtilization(response?.data?.machine_utilization || 0);
        setCycleTime(response?.data?.cycle_time);
        setCycleStarted(true);
      } else if (response.data.success === false) {
        toast.error(response.data.message || "Failed to start production cycle");
      }
    } catch (error) {
      console.error("Error starting cycle:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "An error occurred while starting cycle");
    }
  };
  const submitProductionData = async (
    finalRejected = recycledUnits,
    finalNotes = notes
  ) => {
    const token = getAuthToken();
    if (!token) return;
    const payload = {
      unit_produced: producedUnits,
      unit_rejected: "",
      unit_recycled: finalRejected,
      machine_id: machineId,
      purchase_order_item_id: "1",
      reason: "units were recycled from the process",
      notes: finalNotes,
      batch_id: selectedBatch?.value || "", 
    };
    try {
      const response = await axios.post(
        `${config.API}/production/end`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.success === true) {
        toast.success(response?.data?.message || "Production data submitted successfully");
        setMachineUtilization(response?.data?.machine_utilization || 0);
        setCycleTime(response?.data?.cycle_time);
        setCycleStarted(false);
        setProducedUnits(0);
        setRecycleUnits(0);
        setIsProducedCustom(false);
        setIsRejectedCustom(false);
        setCustomProduced("0");
        setCustomRecycle("0");
        setNotes("");
      } else if (response?.data?.success === false) {
        toast.error(response?.data?.message || "Failed to submit production data");
      }
    } catch (error) {
      console.error(
        "Error submitting production data:",
        error.response?.data || error.message
      );
    }
  };

  const handleSubmitClick = () => {
    if (recycledUnits > 0 && !notes) {
      setShowModal(true);
      setPendingSubmit(true);
    } else {
      submitProductionData(0, "");
    }
  };

  // const issueTypes = [
  //   "Blowhole",
  //   "Incomplete Injection",
  //   "Surface Prepration Error",
  //   "Adhesive Application Error",
  //   "Improper Fusing",
  //   "Contaminate in Mould",
  //   "Inserts Damaged",
  //   "Power Outage",
  // ];


    const issueTypes = [
    "कम भरा हुआ",
    "कच्चा",
    "कम साइज का",
    "अधिक साइज का",
    "जला हुआ रबर",
    "पुराना फ्लैश",
    "बॉन्ड फेल",
    "हवा फंसी हुई",
    "चिपचिपी सतह",
    "गड्ढों के निशान",
    "रबर में दरार",
    "बहाव चिन्ह"
  ];

  const batchOptions = [
    { value: "B001", label: "B001" },
    { value: "B002", label: "B002" },
    { value: "B003", label: "B003" },
    { value: "B004", label: "B004" },
    { value: "B005", label: "B005" },
    { value: "B006", label: "B006" },
    { value: "B007", label: "B007" },
    { value: "B008", label: "B008" },
  ];

  const [selectedBatch, setSelectedBatch] = useState(null);

  return (
    <div className="container-fluid my-4 font_family">
      <div className="card p-4 shadow-sm cycleCard">
        <div className="d-flex align-items-center justify-content-between gap-2 mb-4 flex-wrap">

          {/* Left Section */}
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
            <h5 className="fw-bold mb-0">Cycle Production Logging</h5>
            <div className="d-flex align-items-center gap-3">
              <p className="fw-bold mb-0">Select Batch ID</p>
              <div style={{ width: "250px" }}>
                <Select
                  options={batchOptions}
                  value={selectedBatch}
                  onChange={(option) => setSelectedBatch(option)}
                  placeholder="Choose Batch ID"
                  isSearchable={true}
                />
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="d-flex align-items-center gap-2 flex-wrap w-100">
            <span className="fw-semibold">
              {machineName} ({machineCode})
            </span>
            <span className="text-muted">|</span>
            <span className="fw-semibold">
              {productName}
            </span>
            <span className="ms-auto">
              <TbLoader3
                className={`text-primary ${cycleStarted ? "spin-icon" : ""}`}
                size={22}
              />
            </span>
          </div>

        </div>

        <div className="row logBox">
          <div className="col-md-6 col-sm-6 col-6 bg-success-subtle">
            <label className="fw-semibold">Total Units Produced</label>
            <div className="quantity-control d-flex align-items-center justify-content-between border rounded px-3 py-2">
              <button
                className="qty-btn"
                onClick={decreaseProduced}
                disabled={!cycleStarted}
              >
                −
              </button>
              {isProducedCustom ? (
                <input
                  type="text"
                  className="text-center"
                  value={customProduced}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setCustomProduced(value);
                      setProducedUnits(Number(value));
                    }
                  }}
                  disabled={!cycleStarted}
                  style={{
                    border: "none",
                    boxShadow: "none",
                    outline: "none",
                    fontWeight: "bold",
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <div className="unit-count text-center fw-bold fs-5">
                  {producedUnits}
                </div>
              )}
              <button
                className="qty-btn"
                onClick={increaseProduced}
                disabled={!cycleStarted}
              >
                +
              </button>
            </div>
            <div className="d-flex flex-wrap gap-3 mt-3 ms-2 mb-3">
              {numberOptions.map((num, i) => (
                <div
                  key={i}
                  className={`log_button px-3 py-2 rounded border cycleButton ${producedUnits === num
                    }`}
                  style={{
                    cursor: cycleStarted ? "pointer" : "not-allowed",
                    opacity: cycleStarted ? 1 : 0.5,
                  }}
                  onClick={() => cycleStarted && handleProducedSelect(num)}
                >
                  <b>{num}</b>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-6 col-sm-6 col-6 bg-danger-subtle">
            <label className="fw-semibold">Total Recycled Units</label>
            <div className="quantity-control d-flex align-items-center justify-content-between border rounded px-3 py-2">
              <button
                className="qty-btn"
                onClick={decreaseRejected}
                disabled={!cycleStarted}
              >
                −
              </button>
              {isRejectedCustom ? (
                <input
                  type="text"
                  className="text-center"
                  value={customRecycle}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setCustomRecycle(value);
                      setRecycleUnits(Number(value));
                    }
                  }}
                  disabled={!cycleStarted}
                  style={{
                    border: "none",
                    boxShadow: "none",
                    outline: "none",
                    fontWeight: "bold",
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <div className="unit-count text-center fw-bold fs-5">
                  {recycledUnits}
                </div>
              )}
              <button
                className="qty-btn"
                onClick={increaseRejected}
                disabled={!cycleStarted}
              >
                +
              </button>
            </div>
            <div className="d-flex flex-wrap gap-3 mt-3 ms-2 mb-3 ">
              {numberOptions.map((num, i) => (
                <div
                  key={i}
                  className={`log_button px-3 py-2 rounded border cycleButton ${recycledUnits === num
                    }`}
                  style={{
                    cursor: cycleStarted ? "pointer" : "not-allowed",
                    opacity: cycleStarted ? 1 : 0.5,
                  }}
                  onClick={() => cycleStarted && handleRejectedSelect(num)}
                >
                  <b>{num}</b>
                </div>
              ))}
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row flex-sm-row justify-content-between align-items-stretch gap-2 mt-1">
            <div>
              <button
                className="btn btn-outline-secondary w-100"
                onClick={() => setReportIssuModal(true)}
              >
                + xIssue
              </button>
            </div>
            <div className="d-flex gap-2 flex-column flex-md-row flex-sm-row">
              <div>
                <Button variant="dark" onClick={startProductionCycle} className="w-100">
                  Start Cycle
                </Button>
              </div>
              <div>
                <Button
                  variant="primary"
                  onClick={handleSubmitClick}
                  disabled={!cycleStarted}
                  className="w-100"
                >
                  Submit Data
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4 cycleBox">
        <InfoCard
          title="Cycle Time"
          value={cycleTime?.toFixed(2) || 0} sec
          iconBg="bg-primary bg-opacity-25"
          iconColor="text-primary"
        />
        <InfoCard
          title="Machine Utilization"
          value={`${machineUtilization} %`}
          iconBg="bg-success bg-opacity-25"
          iconColor="text-success"
        />
        <InfoCard
          title="Visual Inspection"
          value="Passed"
          iconBg="bg-success bg-opacity-25"
          iconColor="text-success"
        />
      </div>
      <ReportIssuModal
        show={reportIssuModal}
        handleClose={() => setReportIssuModal(false)}
      />
      <CustomModalOperator
        show={showModal}
        handleClose={() => setShowModal(false)}
        title="Total Recycled Units"
        description="Describe the issue, upload image or voice input."
        buttons={issueTypes}
        count={recycledUnits}
        setCount={setRecycleUnits}
        notes={notes}
        setNotes={setNotes}
        onSend={({ count, notes }) => {
          setRecycleUnits(count);
          setNotes(notes);
          setShowModal(false);
          if (pendingSubmit) {
            submitProductionData(count, notes);
            setPendingSubmit(false);
          }
        }}
      />
    </div>
  );
}
function InfoCard({ title, value, iconBg, iconColor }) {
  return (
    <div className="col-md-4 mb-3">
      <div className="border rounded bg-light p-3 d-flex justify-content-between align-items-center shadow-sm">
        <div>
          <small className="text-muted">{title}</small>
          <div className="fw-bold">{value}</div>
        </div>
        <IoMdCheckmark
          className={`fs-1 p-2 rounded-circle ${iconBg} ${iconColor}`}
        />
      </div>
    </div>
  );
}
